/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />
namespace TabAurous.Production {
    var x;
    @Serenity.Decorators.registerClass()
    export class WorkOrderBOMEditor extends _Ext.MFGTransBOMGridEditor<WorkOrderBOMRow> {
        protected getColumnsKey() { return "Production.WorkOrderBOM"; }
        protected getDialogType() { return WorkOrderBOMDialog; }
        protected getLocalTextPrefix() { return WorkOrderBOMRow.localTextPrefix; }
        protected get_ExtGridOptions() { return Q.deepClone(q.DefaultEditorGridOptions) }
         
        protected form: WorkOrderBOMForm;

        
        constructor(container: JQuery) { 
            super(container); 

            //this.form.ItemTypeId.changeSelect2(e => {
            //    var item = Q.toId(this.form.ItemTypeId.value);
            //    this.setFields(item);
            //});

        }

        public DisableAddButton() {
            this.toolbar.element.hide();
            this.element.hide();
        }

        public EnableAddButton() {
            this.toolbar.element.show();
            this.element.show();
            


        } 
        
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }

        //protected getButtons() {
        //    let buttons = super.getButtons();
        //    var grid = OMS.RawMaterialMasterSelectGrid;
        //    // grid.apply(this.rowSelection = new Serenity.GridRowSelectionMixin(this));
        //    //grid.apply(this.getColumns = (Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));

        //    buttons.push({
        //        title: "Pick Components",
        //        cssClass: "add-button",
        //        onClick: () => {
        //            var pickerDialog = new _Ext.GridItemPickerDialog({
        //                gridType: grid, multiple: true,
        //                preSelectedKeys: this.value.map(k => k.ProductId)
        //            });

        //            pickerDialog.onSuccess = (selectedItems: any[]) => {
        //                let selectedItems2 = selectedItems;
        //                //alert('Length' + selectedItems.length);
        //                var orddetails = [];
        //                var bomdetails = [];
        //                selectedItems2.forEach(function (value) {
        //                    var prdid = value.ProductId;
        //                    var atb = OMS.ProductMasterRow.getLookup().itemById[prdid].AttributeId;
        //                    let ATBDetails = OMS.CommonAttributesRow.getLookup().itemById[atb]

        //                    var Pieces = OMS.ProductMasterRow.getLookup().itemById[prdid].Pieces;
        //                    var Weight = OMS.ProductMasterRow.getLookup().itemById[prdid].Weight;
        //                    var Rate = 0;
        //                    if (ATBDetails.ItemTypeId == 104)
        //                         Rate = Q.first(OMS.MetalRateMasterRow.getLookup().items, x => x.MetalTypeId == ATBDetails.ProductTypeId && x.RateTypeId == 33
        //                            && x.CompanyId == Q.Authorization.userDefinition.CompanyId).Rate;
        //                    if (ATBDetails.ItemTypeId  == 105)
        //                        Rate = RateHelper.GetStoneSalesRate(atb, 0);

        //                    //var Amount = OMS.ProductMasterRow.getLookup().itemById[prdid].A;

        //                    var WorkOrderBOM: WorkOrderBOMRow = {
        //                        BOMProductId: prdid,
        //                        ProductCode: value.ProductCode,
        //                        BOMAttributeId: value.AttributeId,
        //                        Attribute: ATBDetails.Attribute,
        //                        ItemType: ATBDetails.ItemType,
        //                        ItemTypeId: ATBDetails.ItemTypeId,
        //                        CategoryId: ATBDetails.CategoryId,
        //                        SubCategoryCode: ATBDetails.SubCategoryCode,
        //                        StoneColorId: ATBDetails.StoneColorId,
        //                        MetalColorId: ATBDetails.MetalColorId,
        //                        KaratId: ATBDetails.KaratId,
        //                        KaratCode: ATBDetails.KaratCode,
        //                        Rate: Rate,
        //                        Pieces: Pieces,
        //                        Weight: Weight,
        //                        CalcOnId: value.CalcOnId,
        //                        ShapeId: ATBDetails.ShapeId,
        //                        QualityId: ATBDetails.QualityId,
        //                        QualityCode: ATBDetails.QualityCode,
        //                        StdPurity: value.StdPurity,
        //                        Amount: value.CalcOnId == 3 ? Pieces * Rate||0 : Weight * Rate ||0
        //                    };
        //                    orddetails.push(WorkOrderBOM);

        //                });
                        
        //                //alert('Length details' + orddetails.length);
        //                for (let orderDetail of orddetails) {
        //                    orderDetail[this.getIdProperty()] = "`" + this.nextId++;
        //                    //alert('ID ' + orderDetail.PrdId);
        //                    var x = orderDetail;
        //                    this.view.addItem(orderDetail);

        //                }

        //            }

        //            pickerDialog.dialogOpen();
        //        }
        //    });

        //    return buttons;
        //}
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        //validateEntity(row: WorkOrderBOMRow, id: number) {
        //    if (!super.validateEntity(row, id))
        //        return false;


        //    //duplicate Component
        //    //row.WorkOrderBOMId = Q.toId(row.WorkOrderBOMId);

        //    //var sameProduct = Q.tryFirst(this.view.getItems(), x => x.WorkOrderBOMId === row.WorkOrderBOMId);
        //    //if (sameProduct && this.id(sameProduct) !== id) {
        //    //    Q.alert('This Component is already in product details!');
        //    //   return false;
        //    //}

        //     //update values in grid

        //    row.ProductCode = ProductMasterRow.getLookup().itemById[row.WorkOrderBOMId].ProductCode; 
        //    return true;
        //}    

 
    }
}